import { Head, Link } from '@inertiajs/react'
import { AppShell } from '@/layouts/AppShell'
import { PageHeader } from '@/components/layout/PageHeader'
import { Card } from '@/components/ui/Card'
import type { Breadcrumb } from '@/types/shared'

export type TeamProfileApprovalsIndexProps = {
  requests: Array<{
    id: string
    status: string
    name: string
    positions: string[]
    submittedAt: string
  }>
  breadcrumbs: Breadcrumb[]
}

export default function TeamProfileApprovalsIndex({ requests, breadcrumbs }: TeamProfileApprovalsIndexProps) {
  return (
    <AppShell>
      <Head title="プロフィール承認" />
      <PageHeader
        title="プロフィール承認リクエスト"
        description="承認待ちのプロフィールを確認し、最新の情報に更新してください。"
        breadcrumbs={breadcrumbs}
      />

      <Card>
        {requests.length === 0 ? (
          <div className="flex flex-col items-center justify-center py-16 text-sm text-white/60">
            <p>現在、承認待ちのリクエストはありません。</p>
          </div>
        ) : (
          <ul className="divide-y divide-white/5">
            {requests.map((request) => (
              <li key={request.id}>
                <Link
                  href={`/team/profile_approvals/${request.id}`}
                  className="flex items-center justify-between px-4 py-4 text-sm text-white transition hover:bg-white/5"
                >
                  <div>
                    <p className="font-semibold text-white">{request.name}</p>
                    <p className="text-xs text-white/60">
                      申請ID: {request.id} · {request.status}
                    </p>
                    <p className="text-xs text-white/60">
                      {request.positions.length ? request.positions.join(', ') : 'ポジション未設定'} · {formatDate(request.submittedAt)} 提出
                    </p>
                  </div>
                  <span className="text-brand-300">詳細 →</span>
                </Link>
              </li>
            ))}
          </ul>
        )}
      </Card>
    </AppShell>
  )
}

function formatDate(value: string) {
  return new Date(value).toLocaleString('ja-JP', {
    month: 'numeric',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  })
}
